
import { Component, Vue } from 'vue-property-decorator';
import { NewNote, Note, Snackbar, CardColors } from '@/store/types';
import { namespace } from 'vuex-class';
import { SnackbarColorTypes, CardColorTypes } from '../store/types';
import ColorPickerMenu from './ColorPickerMenu.vue';

const globalModule = namespace('global');
const notesModule = namespace('notes');

@Component({
  components: {
    ColorPickerMenu,
  },
})
export default class Create extends Vue {
  note: NewNote = {
    title: '',
    content: '',
    color: CardColorTypes.Default,
  };

  get colors() {
    return CardColorTypes;
  }

  titleFieldVisible = false;
  actionsVisible = false;

  @globalModule.State
  colorMenuOpen!: boolean;

  showTitleFieldAndActions() {
    this.titleFieldVisible = true;
    this.actionsVisible = true;
  }

  hideTitleFieldAndActions() {
    this.titleFieldVisible = false;
    this.actionsVisible = false;
  }

  colorSelected(color: CardColors) {
    this.note.color = CardColorTypes[color];
  }

  onClickOutside() {
    if (!this.colorMenuOpen) {
      this.close();
    }
  }

  @notesModule.Action
  createNote!: (newNote: NewNote) => Promise<Note>;

  @globalModule.Mutation
  showSnackbar!: (snackbar: Snackbar) => void;

  async close() {
    this.hideTitleFieldAndActions();

    if (this.note.title || this.note.content) {
      await this.createNote(this.note);
      this.showSnackbar({
        open: true,
        text: 'Note saved',
        color: SnackbarColorTypes.Success,
      });
    }

    this.note = {
      title: '',
      content: '',
      color: CardColorTypes.Default,
    };
  }
}
